// extracted by mini-css-extract-plugin
module.exports = {"page":"login_page__3Of-_","light":"login_light__2Y7G2","noAccountDisclaimer":"login_noAccountDisclaimer__atBm2","container":"login_container__2wyBj","footer":"login_footer__2Hvi3"};